import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkDateDisplay } from './uitk-date-display.esm.js';
import styles from '../uitk-date-selector.css';

/* eslint-disable @typescript-eslint/no-empty-function */
var getClassNameList = classNames.bind(styles);
var dateSelectorPlaybackClassName = 'uitk-date-selector-playback';
var arrowIconClassName = "".concat(dateSelectorPlaybackClassName, "-icon");
var UitkDateSelectorPlayback = function (props) {
    var locale = props.locale, startLabel = props.startLabel, endLabel = props.endLabel, startDate = props.startDate, endDate = props.endDate, dateFormatOptions = props.dateFormatOptions, _a = props.updateSelectionChangeMode, updateSelectionChangeMode = _a === void 0 ? function () { } : _a, selectionChangeMode = props.selectionChangeMode, isMultiPlaybackDateDisplay = props.isMultiPlaybackDateDisplay, isFullSizePlaybackDateDisplay = props.isFullSizePlaybackDateDisplay;
    var l10n = useLocalization();
    var isStartActive = selectionChangeMode === 'start';
    var isEndActive = !isStartActive;
    var defaultStartLabel = l10n.formatText('dateSelector.startDate.label');
    var defaultEndLabel = l10n.formatText('dateSelector.endDate.label');
    var dateDisplayId1 = Math.random().toString(36).substring(7);
    var dateDisplayId2 = Math.random().toString(36).substring(7);
    var handleClickStartDateDisplay = function () {
        updateSelectionChangeMode('start');
    };
    var handleClickEndDateDisplay = function () {
        // If there is an end date, allow user to select end date-display
        // Otherwise do nothing
        if (endDate) {
            updateSelectionChangeMode('end');
        }
    };
    return (React.createElement(UitkLayoutFlex, { "data-testid": "date-selector-playback", direction: "row", alignItems: "center", className: getClassNameList(dateSelectorPlaybackClassName) },
        React.createElement(UitkLayoutFlexItem, null,
            React.createElement(UitkDateDisplay, { id: dateDisplayId1, locale: locale, label: startLabel || defaultStartLabel, date: startDate || null, dateFormatOptions: dateFormatOptions, isActive: isStartActive, isFullSize: isFullSizePlaybackDateDisplay, onDateDisplayClick: handleClickStartDateDisplay })),
        isMultiPlaybackDateDisplay && (React.createElement(React.Fragment, null,
            React.createElement(UitkLayoutFlexItem, null,
                React.createElement(UitkSpacing, { margin: { inline: 'three' } },
                    React.createElement(UitkIcon, { name: "arrow_forward", size: UitkIconSize.SMALL, className: getClassNameList(arrowIconClassName) }))),
            React.createElement(UitkLayoutFlexItem, null,
                React.createElement(UitkDateDisplay, { id: dateDisplayId2, locale: locale, label: endLabel || defaultEndLabel, date: endDate || null, dateFormatOptions: dateFormatOptions, isActive: isEndActive, isFullSize: isFullSizePlaybackDateDisplay, onDateDisplayClick: handleClickEndDateDisplay }))))));
};

export { UitkDateSelectorPlayback };
